// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { CookiePolicyPage } from '../pages/CookiePolicyPage/CookiePolicyPage';

export const Route = createFileRoute('/cookie-policy')({
  component: CookiePolicyPage,
});
